// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

/**
 * MCE shuttle-service floors.
 *
 * Parameter category 26 (26/14 from schema 4.0.0, 26/3 before): which floors
 * the car serves in shuttle service, and the car-call disposition the
 * controller applies.
 */
export class ShuttleFloorsMessage implements flatbuffers.IUnpackableObject<ShuttleFloorsMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ShuttleFloorsMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsShuttleFloorsMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ShuttleFloorsMessage,
  ): ShuttleFloorsMessage {
    return (obj || new ShuttleFloorsMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsShuttleFloorsMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ShuttleFloorsMessage,
  ): ShuttleFloorsMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ShuttleFloorsMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  car(): number {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  eligibleFloors(index: number): boolean | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? !!this.bb!.readInt8(this.bb!.__vector(this.bb_pos + offset) + index) : false;
  }

  eligibleFloorsLength(): number {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__vector_len(this.bb_pos + offset) : 0;
  }

  eligibleFloorsArray(): Int8Array {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return new Int8Array(
      this.bb!.bytes().buffer,
      this.bb!.bytes().byteOffset + this.bb!.__vector(this.bb_pos + offset),
      this.bb!.__vector_len(this.bb_pos + offset),
    );
  }

  carCallDisposition(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readInt32(this.bb_pos + offset) : 0;
  }

  static startShuttleFloorsMessage(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addCar(builder: flatbuffers.Builder, car: number) {
    builder.addFieldInt32(0, car, 0);
  }

  static addEligibleFloors(builder: flatbuffers.Builder, eligibleFloorsOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, eligibleFloorsOffset, 0);
  }

  static createEligibleFloorsVector(
    builder: flatbuffers.Builder,
    data: boolean[],
  ): flatbuffers.Offset {
    builder.startVector(1, data.length, 1);
    for (let i = data.length - 1; i >= 0; i--) {
      builder.addInt8(+data[i]!);
    }
    return builder.endVector();
  }

  static startEligibleFloorsVector(builder: flatbuffers.Builder, numElems: number) {
    builder.startVector(1, numElems, 1);
  }

  static addCarCallDisposition(builder: flatbuffers.Builder, carCallDisposition: number) {
    builder.addFieldInt32(2, carCallDisposition, 0);
  }

  static endShuttleFloorsMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // eligible_floors
    return offset;
  }

  static createShuttleFloorsMessage(
    builder: flatbuffers.Builder,
    car: number,
    eligibleFloorsOffset: flatbuffers.Offset,
    carCallDisposition: number,
  ): flatbuffers.Offset {
    ShuttleFloorsMessage.startShuttleFloorsMessage(builder);
    ShuttleFloorsMessage.addCar(builder, car);
    ShuttleFloorsMessage.addEligibleFloors(builder, eligibleFloorsOffset);
    ShuttleFloorsMessage.addCarCallDisposition(builder, carCallDisposition);
    return ShuttleFloorsMessage.endShuttleFloorsMessage(builder);
  }

  unpack(): ShuttleFloorsMessageT {
    return new ShuttleFloorsMessageT(
      this.car(),
      this.bb!.createScalarList<boolean>(
        this.eligibleFloors.bind(this),
        this.eligibleFloorsLength(),
      ),
      this.carCallDisposition(),
    );
  }

  unpackTo(_o: ShuttleFloorsMessageT): void {
    _o.car = this.car();
    _o.eligibleFloors = this.bb!.createScalarList<boolean>(
      this.eligibleFloors.bind(this),
      this.eligibleFloorsLength(),
    );
    _o.carCallDisposition = this.carCallDisposition();
  }

  unpackFields(...fields: string[]): ShuttleFloorsMessageT {
    const t = new ShuttleFloorsMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("car")) {
      t.car = this.car();
    }
    if (fieldSet.has("eligible_floors")) {
      t.eligibleFloors = this.bb!.createScalarList<boolean>(
        this.eligibleFloors.bind(this),
        this.eligibleFloorsLength(),
      );
    }
    if (fieldSet.has("car_call_disposition")) {
      t.carCallDisposition = this.carCallDisposition();
    }
    return t;
  }
}

export class ShuttleFloorsMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public car: number = 0,
    public eligibleFloors: boolean[] = [],
    public carCallDisposition: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.eligibleFloors === null || this.eligibleFloors === undefined) {
      throw new Error('Required field "eligible_floors" is not set');
    }
    const eligibleFloors = ShuttleFloorsMessage.createEligibleFloorsVector(
      builder,
      this.eligibleFloors,
    );

    return ShuttleFloorsMessage.createShuttleFloorsMessage(
      builder,
      this.car,
      eligibleFloors,
      this.carCallDisposition,
    );
  }

  clone(): ShuttleFloorsMessageT {
    const obj = new ShuttleFloorsMessageT();
    obj.car = this.car;
    obj.eligibleFloors = [...this.eligibleFloors];
    obj.carCallDisposition = this.carCallDisposition;
    return obj;
  }

  equals(other: ShuttleFloorsMessageT): boolean {
    if (this.car !== other.car) return false;
    if (this.eligibleFloors.length !== other.eligibleFloors.length) return false;
    for (let i = 0; i < this.eligibleFloors.length; i++) {
      if (this.eligibleFloors[i] !== other.eligibleFloors[i]) return false;
    }
    if (this.carCallDisposition !== other.carCallDisposition) return false;
    return true;
  }
}

export function verifyShuttleFloorsMessage(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 4);
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkVector(pos, 1);
      }
    }
    verifier.checkRequiredField(tablePos, 6, "eligible_floors");
    verifier.checkScalarField(tablePos, 8, 4);
  } finally {
    verifier.popDepth();
  }
}
